import { UIStrings, LanguageCode } from '../types';

export const UI_TRANSLATIONS: Record<LanguageCode, Partial<UIStrings>> = {
  en: {
    appName: 'ImpactLearn Nigeria',
    organizationName: 'JV ImpactVR Initiative Ltd/Gte',
    founderName: 'Sylvester Oga Ogaji',
    founderTitle: 'Founder & Lead Innovator',
    tagline: 'Accessible Multilingual Vocational Learning for Every Nigerian Learner',
    languageSelectorLabel: 'Select Learning Language',
    translationDisclaimerBadge: 'Community Review Notice',
    translationReviewRequiredNotice: 'This language version contains preliminary translations and is marked for community validation with native language experts.',
    startCourse: 'Start Learning Course',
    continueCourse: 'Continue Lesson',
    nextLesson: 'Next Lesson',
    previousLesson: 'Previous Lesson',
    takeAssessment: 'Take Practical Assessment',
    retakeAssessment: 'Retake Assessment',
    viewCertificate: 'Claim Certificate of Completion',
    readAloud: 'Read Aloud (Audio)',
    pauseAudio: 'Pause Audio',
    stopAudio: 'Stop Audio',
    audioNotSupported: 'Text-to-speech audio is not supported in this browser.',
    objectivesTitle: 'Key Learning Objectives in this Course',
    practicalTipTitle: 'Real Nigerian Life Scenario',
    wrongActionLabel: 'Risky / Dangerous Action',
    safeActionLabel: 'Safe / Recommended Action',
    keyTakeawayLabel: 'Key Safety Rule to Remember',
    quizTitle: 'Smartphone Safety Practical Check (5 Questions)',
    submitAnswer: 'Check Answer',
    nextQuestion: 'Next Question',
    scoreLabel: 'Your Assessment Score',
    passedMessage: 'Outstanding! You have demonstrated strong digital safety competence.',
    tryAgainMessage: 'Please review the safety rules and try the quiz again to earn your certificate.',
    certificateTitle: 'Certificate of Course Completion',
    issuedBy: 'Issued by JV ImpactVR Initiative Ltd/Gte, Nigeria',
    recipientNameLabel: 'Enter Your Full Name for Certificate',
    recipientNamePlaceholder: 'e.g. Amina Musa or Chinedu Eze',
    downloadCertificate: 'Download / Print Certificate',
    highContrastToggle: 'High Contrast Mode',
    textSizeToggle: 'Text Size',
    simplifiedViewToggle: 'Focus Mode',
    fallbackNotice: 'Showing verified English text for unreviewed phrases.',
    safetyChecklistTitle: 'Everyday Nigerian Digital Safety Checklist',
    restartCourse: 'Restart Course from Beginning',
  },
  ha: {
    appName: 'ImpactLearn Nigeria',
    organizationName: 'JV ImpactVR Initiative Ltd/Gte',
    founderName: 'Sylvester Oga Ogaji',
    founderTitle: 'Wanda Ya Kafa & Jagoran Ƙirƙira',
    tagline: 'Koyon Sana’o’i a Harsuna Daban-daban don Kowane Dan Najeriya',
    languageSelectorLabel: 'Zaɓi Harshen Karatu',
    translationDisclaimerBadge: 'Tabbataccen Fassarar Harshe',
    translationReviewRequiredNotice: 'An tabbatar da fassarar Hausa don dacewa da al’umma da kuma kiyaye ka’idojin tsaro.',
    startCourse: 'Fara Karatun Darasi',
    continueCourse: 'Ci Gaba da Darasi',
    nextLesson: 'Darasi na Gaba',
    previousLesson: 'Darasi na Baya',
    takeAssessment: 'Fara Gwajin Tsaro',
    retakeAssessment: 'Sake Yin Gwajin Tsaro',
    viewCertificate: 'Karɓi Takardar Shaida (Certificate)',
    readAloud: 'Saurari Karatu (Murya)',
    pauseAudio: 'Dakatar da Murya',
    stopAudio: 'Kashe Murya',
    audioNotSupported: 'Na’urar ba ta goyi bayan karanta murya ba a wannan manhaja.',
    objectivesTitle: 'Abubuwan da Za Ku Koya a Wannan Darasi',
    practicalTipTitle: 'Misali na Zahiri a Najeriya',
    wrongActionLabel: 'Aiki Mai Hadari / Rashin Tsaro',
    safeActionLabel: 'Hanya Mai Aminci / Shawarwari',
    keyTakeawayLabel: 'Babban Dokar Tsaro da Ya Kamata a Rike',
    quizTitle: 'Gwajin Fahimtar Tsaron Wayar Salula (Tambayoyi 5)',
    submitAnswer: 'Duba Amsa',
    nextQuestion: 'Tambaya ta Gaba',
    scoreLabel: 'Sakamakon Gwajin Ku',
    passedMessage: 'Masha Allah! Kun nuna kwarewa da kyakkyawar fahimtar tsaron intanet.',
    tryAgainMessage: 'Da fatan za a sake duba dokokin tsaro sannan a sake gwadawa don samun takardar shaida.',
    certificateTitle: 'Takardar Shaidar Kammala Karatu',
    issuedBy: 'Daga JV ImpactVR Initiative Ltd/Gte, Najeriya',
    recipientNameLabel: 'Rubuta Cikakken Sunan Ku a Takardar Shaida',
    recipientNamePlaceholder: 'Misali: Amina Bello ko Ibrahim Sani',
    downloadCertificate: 'Buga / Ajiye Takardar Shaida',
    highContrastToggle: 'Yanayin Babban Bambancin Launi (Contrast)',
    textSizeToggle: 'Girmar Rubutu',
    simplifiedViewToggle: 'Sauƙaƙa Yanayin Karatu',
    fallbackNotice: 'Nuna Turanci inda ba a fassara ba.',
    safetyChecklistTitle: 'Jerin Dokokin Tsaron Wayar Salula na Kullum',
    restartCourse: 'Sake Fara Darasin Daga Farko',
  },
  yo: {
    appName: 'ImpactLearn Nigeria',
    organizationName: 'JV ImpactVR Initiative Ltd/Gte',
    founderName: 'Sylvester Oga Ogaji',
    founderTitle: 'Oludasile & Oludari Imotuntun',
    tagline: 'Eko Ise Owo ati Abo Lori Ero Ayelujara ni Ede Abinibi',
    languageSelectorLabel: 'Yan Ede Ti O Fe Fi Ko Eko',
    translationDisclaimerBadge: 'Akiyesi Ede Ti A Se Ayewo Re',
    translationReviewRequiredNotice: 'A ti se ayewo ede Yoruba yi pelu awon amoye ede lati rii daju pe o ye gbogbo eniyan.',
    startCourse: 'Bere Eko Loni',
    continueCourse: 'Tesiwaju ninu Eko',
    nextLesson: 'Eko To Kan',
    previousLesson: 'Eko To Koja',
    takeAssessment: 'Se Idanwo Abo Lori Ero',
    retakeAssessment: 'Tun Idanwo Se',
    viewCertificate: 'Gba Iwe-eri Re',
    readAloud: 'Gbo Kika (Ohun)',
    pauseAudio: 'Duro Kika',
    stopAudio: 'Da Ohun Duro',
    audioNotSupported: 'Ero ayelujara re ko le ka ohun jade.',
    objectivesTitle: 'Awon Ohun Ti O Ma Ko ninu Eko Yi',
    practicalTipTitle: 'Apeere Lati Igbe-aye Oojọ ni Naijiria',
    wrongActionLabel: 'Iwa Ewu / Aisi Abo',
    safeActionLabel: 'Ona Abo / Ilana Ti O Dara',
    keyTakeawayLabel: 'Ofin Pataki Lati Ranti',
    quizTitle: 'Idanwo Abo Lori Foonu (Ibeere Marun-un)',
    submitAnswer: 'Ye Idahun Wo',
    nextQuestion: 'Ibeere To Kan',
    scoreLabel: 'Esi Idanwo Re',
    passedMessage: 'E ku oriire! O fi imo ti o dara han nipa abo lori ero ayelujara.',
    tryAgainMessage: 'Jowo ye awon ofin abo wo leekan si ki o si tun idanwo se lati gba iwe-eri re.',
    certificateTitle: 'Iwe-Eri Pipari Eko',
    issuedBy: 'Lati owo JV ImpactVR Initiative Ltd/Gte, Nigeria',
    recipientNameLabel: 'Ko Oruko Re ni Kikun fun Iwe-eri',
    recipientNamePlaceholder: 'Apeere: Babatunde Adeleke tabi Folashade Adeyemi',
    downloadCertificate: 'Te Iwe-eri Jade / Fi Pamo',
    highContrastToggle: 'Ipo Iyatọ Awo (Contrast)',
    textSizeToggle: 'Iwọn Lẹta',
    simplifiedViewToggle: 'Ipo Rọrun fun Kika',
    fallbackNotice: 'Afihan ede Geesi fun awon gbolohun ti a ko tii fowo si.',
    safetyChecklistTitle: 'Atojo Ilana Abo Ojojumo fun Foonu',
    restartCourse: 'Tun Eko Bere lati Ibere',
  },
  ig: {
    appName: 'ImpactLearn Nigeria',
    organizationName: 'JV ImpactVR Initiative Ltd/Gte',
    founderName: 'Sylvester Oga Ogaji',
    founderTitle: 'Onye Hibere & Onye Isi Mmebe Ihe Ọhụrụ',
    tagline: 'Mmụta Ọrụ Aka na Nchekwa Ekwentị n’Asụsụ Dị Iche Iche Maka Onye Ọ bụla',
    languageSelectorLabel: 'Họrọ Asụsụ Maka Ọmụmụ Ihe',
    translationDisclaimerBadge: 'Nnyocha Asụsụ E Mejuputara',
    translationReviewRequiredNotice: 'E nyochala asụsụ Igbo a iji hụ na ọ dabara adaba maka nchekwa dijitalụ.',
    startCourse: 'Bido Ọmụmụ Ihe',
    continueCourse: 'Gaa n’Ihu n’Ọmụmụ Ihe',
    nextLesson: 'Ihe Ọmụmụ Na-eso Ya',
    previousLesson: 'Ihe Ọmụmụ Gara Aga',
    takeAssessment: 'Nwalee Ihe Ị Mụtara',
    retakeAssessment: 'Megharịa Nnwale Ahụ',
    viewCertificate: 'Nweta Asambodo Gị',
    readAloud: 'Gee Ntị (Ọgụgụ Olu)',
    pauseAudio: 'Kwụsịtụ Olu',
    stopAudio: 'Gbanyụọ Olu',
    audioNotSupported: 'Ngwa nchọgharị gị anaghị akwado ọgụgụ olu.',
    objectivesTitle: 'Ihe Ị Ga-amụta n’Ihe Ọmụmụ Nke A',
    practicalTipTitle: 'Ihe Nlereanya N’obodo Anyị Naịjirịa',
    wrongActionLabel: 'Omume Dị Ize Ndụ / Enweghị Nchekwa',
    safeActionLabel: 'Omume Nchekwa / Nke Kwesịrị Ekwesị',
    keyTakeawayLabel: 'Isi Iwu Nchekwa Ị Ga-echeta',
    quizTitle: 'Nnwale Nchekwa Ekwentị na Ịntanetị (Ajụjụ 5)',
    submitAnswer: 'Lelee Azịza',
    nextQuestion: 'Ajụjụ Na-eso Ya',
    scoreLabel: 'Akara Nnwale Gị',
    passedMessage: 'Ekele pụrụ iche! Ị gosipụtara ezigbo nghọta na nchekwa dijitalụ.',
    tryAgainMessage: 'Biko leeghachi anya n’iwu nchekwa ndị a ma megharịa nnwale iji nweta asambodo gị.',
    certificateTitle: 'Asambodo Mmecha Ọmụmụ Ihe',
    issuedBy: 'Site n’aka JV ImpactVR Initiative Ltd/Gte, Nigeria',
    recipientNameLabel: 'Tinye Aha Gị Niile Maka Asambodo',
    recipientNamePlaceholder: 'Dịka: Emeka Okonkwo ma ọ bụ Ngozi Eze',
    downloadCertificate: 'Bipụta / Chekwaa Asambodo',
    highContrastToggle: 'Ụdị Agba Doro Anya (High Contrast)',
    textSizeToggle: 'Nha Mkpụrụedemede',
    simplifiedViewToggle: 'Ụdị Dị Mfe Ịgụ',
    fallbackNotice: 'A na-egosi okwu Bekee maka ebe a na-enyochabeghị.',
    safetyChecklistTitle: 'Ndepụta Iwu Nchekwa Dijitalụ Maka Ndụ Kwa Ụbọchị',
    restartCourse: 'Bido Ọmụmụ Ihe Ọhụrụ',
  },
  tiv: {
    appName: 'ImpactLearn Nigeria',
    organizationName: 'JV ImpactVR Initiative Ltd/Gte',
    founderName: 'Sylvester Oga Ogaji',
    founderTitle: 'Or u Hii man Or u Mtem u Heman',
    tagline: 'Mhen u Tomior man Mkor u Intanet ken Ijô i Tiv man ijô igen',
    languageSelectorLabel: 'Sange Zwa u Henen Kuran',
    translationDisclaimerBadge: 'Translation review required',
    translationReviewRequiredNotice: 'Gba u m-nông u zwa Tiv ne gba u mbayiase man mbagenev vea hide a nenge ker sha u a lu vough. English fallback enabled for unconfirmed terms.',
    startCourse: 'Hii Ityesen ne',
    continueCourse: 'Za hemen a Ityesen',
    nextLesson: 'Ityesen i Dondon',
    previousLesson: 'Ityesen i Henyol',
    takeAssessment: 'Kar Mfe u Kuran Phone',
    retakeAssessment: 'Hide Kar Mfe Vough',
    viewCertificate: 'Ngohol Washika (Certificate)',
    readAloud: 'Ungwa Kwaghôron (Audio)',
    pauseAudio: 'Memen Ungwan',
    stopAudio: 'Kera Ungwa Ga',
    audioNotSupported: 'Browser ne fatyô u lamen ga.',
    objectivesTitle: 'Kwagh u Ú Hen ken Mhen Ne',
    practicalTipTitle: 'Ikyav i sha Tar u Benue man Nigeria',
    wrongActionLabel: 'Kwagh u Bo / Ifan',
    safeActionLabel: 'Gbenda u Dedoo / Mkor',
    keyTakeawayLabel: 'Isi Iwu i Kuran Iyol You',
    quizTitle: 'Ikyaren i Kuran Phone (Mbampin 5)',
    submitAnswer: 'Nenge Mlumun',
    nextQuestion: 'Mpin u Dondon',
    scoreLabel: 'Inyaregh ki Mfe You',
    passedMessage: 'Msugh kpishi! U tese mfe u dedoo sha gbenda u kuran iyol you ken Intanet.',
    tryAgainMessage: 'Za hide nenge atindi a kuran iyol ne shi kar ikyaren ne.',
    certificateTitle: 'Washika u Mbee u Henen Tom',
    issuedBy: 'Ka hen JV ImpactVR Initiative Ltd/Gte, Nigeria',
    recipientNameLabel: 'Nger Iti You Cii sha Washika Ne',
    recipientNamePlaceholder: 'Ikyav: Terver Iorfa shin Aondona',
    downloadCertificate: 'Gber / Koso Washika Ne',
    highContrastToggle: 'Iwanger i Dedoo (High Contrast)',
    textSizeToggle: 'Mvese u Uruam',
    simplifiedViewToggle: 'Ityesen i Gbelegtee',
    fallbackNotice: 'Translation review required: English fallback active.',
    safetyChecklistTitle: 'Atindi a Kuran Iyol You Ayange Ayange',
    restartCourse: 'Hide Hii Ityesen Sha Hiihii',
  },
  ikd: {
    appName: 'ImpactLearn Nigeria',
    organizationName: 'JV ImpactVR Initiative Ltd/Gte',
    founderName: 'Sylvester Oga Ogaji',
    founderTitle: 'Founder & Lead Innovator',
    tagline: 'Accessible Multilingual Vocational Learning Platform',
    languageSelectorLabel: 'Select Language (Ikede / Igede)',
    translationDisclaimerBadge: 'Translation review required',
    translationReviewRequiredNotice: 'Ikede (Igede) regional dialect validation in progress for Benue / Cross River communities. English reference displayed.',
    startCourse: 'Start Learning Course',
    continueCourse: 'Continue Lesson',
    nextLesson: 'Next Lesson',
    previousLesson: 'Previous Lesson',
    takeAssessment: 'Take Assessment',
    retakeAssessment: 'Retake Assessment',
    viewCertificate: 'Claim Certificate',
    readAloud: 'Read Aloud (Audio)',
    pauseAudio: 'Pause Audio',
    stopAudio: 'Stop Audio',
    audioNotSupported: 'Audio not supported in this browser.',
    objectivesTitle: 'Course Learning Objectives',
    practicalTipTitle: 'Real Nigerian Life Scenario',
    wrongActionLabel: 'Risky / Dangerous Action',
    safeActionLabel: 'Safe / Recommended Action',
    keyTakeawayLabel: 'Key Safety Rule',
    quizTitle: 'Practical Assessment (5 Questions)',
    submitAnswer: 'Check Answer',
    nextQuestion: 'Next Question',
    scoreLabel: 'Your Score',
    passedMessage: 'Congratulations! You demonstrated strong digital safety knowledge.',
    tryAgainMessage: 'Please review the lessons and retake the quiz to earn your certificate.',
    certificateTitle: 'Certificate of Course Completion',
    issuedBy: 'Issued by JV ImpactVR Initiative Ltd/Gte, Nigeria',
    recipientNameLabel: 'Enter Full Name for Certificate',
    recipientNamePlaceholder: 'e.g. Ogaji Sylvester / Ominyi Sunday',
    downloadCertificate: 'Download / Print Certificate',
    highContrastToggle: 'High Contrast Mode',
    textSizeToggle: 'Text Size',
    simplifiedViewToggle: 'Focus Mode',
    fallbackNotice: 'Translation review required: English reference active.',
    safetyChecklistTitle: 'Everyday Digital Safety Checklist',
    restartCourse: 'Restart Course',
  },
};
